var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 61.217,
    style: {
      fill: "#BDDBFF"
    },
    width: 512,
    height: 389.565
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 61.217,
    style: {
      fill: "#9BC9FF"
    },
    width: 256,
    height: 389.565
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,61.217v389.565h512V61.217H0z M478.609,417.391H33.391V94.609h445.217V417.391z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 300.522,
    y: 150.261,
    style: {
      fill: "#004FAC"
    },
    width: 133.565,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.522,
    y: 328.348,
    style: {
      fill: "#004FAC"
    },
    width: 133.565,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.522,
    y: 239.304,
    style: {
      fill: "#004FAC"
    },
    width: 133.565,
    height: 33.391
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#004FAC"
    },
    points: "256,161.391 222.609,161.391 222.609,128 111.304,128 111.304,161.391 77.913,161.391  77.913,272.696 111.304,272.696 111.304,306.087 144.696,306.087 144.696,339.478 100.174,339.478 100.174,384 233.739,384  233.739,339.478 189.217,339.478 189.217,306.087 222.609,306.087 222.609,272.696 256,272.696  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileuser);
export default __webpack_public_path__ + "static/media/profileuser.a550425ce79696e698be5d2cf8c5d058.svg";
export { ForwardRef as ReactComponent };